// extracted by mini-css-extract-plugin
export var chip = "_he-0";
export var filterDropdown = "_he-5";
export var filterItem = "_he-6";
export var icon = "_he-1";
export var removeButton = "_he-3";
export var removeIcon = "_he-4";
export var separator = "_he-2";